import { Component, Input, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';
import { CardType } from '../../../common';

@Component({
  selector: 'skc-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.less']
})
export class CardComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-card-border') cardBorder = true;
  @Input('skc-body-style') bodyStyle;
  @Input('skc-card-type') cardType: CardType;
  currentCardType = CardType;

  constructor() {
    super();
  }

  ngOnInit() {}
}
